// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__kJlEd","rotate":"LoadingSpinner_rotate__pkSRF"};